import React from "react";

// We import bootstrap to make our application look better.
import "bootstrap/dist/css/bootstrap.css";


// Here, we display our Navbar
export default function Navbar() {
return (
    <nav className="navbar navbar-light bg-light">
    <h2 className="text-dark" style={{"width" : 10 + '%',"height": 10+"%","border-left": "4px solid #109B58", "padding-left":1+"%"}}>Bad Blogs</h2>
    </nav>
);
}
